export default __webpack_public_path__ + "static/media/art.7048d37e.svg";